import { Component } from 'react';
import './header.scss';
import { FaReact } from 'react-icons/fa';

class Header extends Component {
    render() {
        return (
            <header className="header">
                <div className="header__svg"> <FaReact /> </div>
                <h1 className="header__title">Calculator App</h1>
                <div className='header__container'>
                    <a className="header__link" id='counter-link' href='#counter'>Counter</a>
                    <a className="header__link" id='calculator-link' href='#calculator'>Calculator</a>
                </div>
            </header>
        )
    }
}

export default Header;